// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__Y_uDs","pagination":"style_pagination__8BMGS"};